import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Globe, MessageCircle, Code } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer" role="contentinfo">

      {/* ── Footer Top CTA Banner ── */}
      <div className="footer-top">
        <h2>Ready to accelerate your digital transformation?</h2>
        <p>Join 50+ forward-thinking enterprises that trust Wayug Infotech for mission-critical technology.</p>
        <div className="footer-top-actions">
          <a href="https://wa.me/918287999236?text=Hi!%20I%20would%20like%20to%20start%20a%20project%20with%20Wayug%20Infotech." target="_blank" rel="noopener noreferrer" className="btn btn-primary">Start a Project</a>
          <a href="https://wa.me/918287999236?text=Hi!%20I%20would%20like%20to%20schedule%20a%20call." target="_blank" rel="noopener noreferrer" className="btn btn-outline">Schedule a Call</a>
        </div>
      </div>

      {/* ── Footer Main ── */}
      <div className="footer-main container">

        {/* Brand Column */}
        <div className="footer-brand">
          <Link to="/" aria-label="Wayug Infotech Solutions — Home">
            <img
              src="/logofull.png"
              alt="Wayug Infotech Solutions Logo"
              className="footer-logo-img"
              width="160"
              height="40"
              loading="lazy"
              decoding="async"
            />
          </Link>
          <p>
            Enterprise IT consulting, custom software development, and managed services
            for startups and enterprises across India.
          </p>

          {/* Semantic address for Local SEO */}
          <address className="footer-contact-list" style={{ fontStyle: 'normal' }} itemScope itemType="https://schema.org/LocalBusiness">
            <meta itemProp="name" content="Wayug Infotech Solutions" />
            <div className="footer-contact-item" itemProp="telephone">
              <Phone size={15} aria-hidden="true" />
              <a href="tel:+918287999236" style={{ color: 'inherit', textDecoration: 'none' }}>+91 8287999236</a>
            </div>
            <div className="footer-contact-item" itemProp="email">
              <Mail size={15} aria-hidden="true" />
              <a href="mailto:wayugpl@gmail.com" style={{ color: 'inherit', textDecoration: 'none' }}>wayugpl@gmail.com</a>
            </div>
            <div className="footer-contact-item" itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
              <MapPin size={15} aria-hidden="true" />
              <span>
                <span itemProp="streetAddress">Connaught Place</span>,{' '}
                <span itemProp="addressLocality">New Delhi</span>,{' '}
                <span itemProp="addressRegion">Delhi</span>{' '}
                <span itemProp="postalCode">110001</span>
              </span>
            </div>
          </address>

          <div className="footer-social" aria-label="Social media links">
            <a href="https://www.linkedin.com/company/wayug-infotech" className="social-link" target="_blank" rel="noopener noreferrer" aria-label="Wayug Infotech on LinkedIn">
              <Globe size={16} aria-hidden="true" />
            </a>
            <a href="https://twitter.com/wayug" className="social-link" target="_blank" rel="noopener noreferrer" aria-label="Wayug Infotech on Twitter">
              <MessageCircle size={16} aria-hidden="true" />
            </a>
            <a href="https://github.com/wayug" className="social-link" target="_blank" rel="noopener noreferrer" aria-label="Wayug Infotech on GitHub">
              <Code size={16} aria-hidden="true" />
            </a>
          </div>
        </div>

        {/* Links Grid */}
        <div className="footer-links-grid">

          {/* Column 1 — Solutions */}
          <nav className="footer-column" aria-label="Service solutions navigation">
            <h4>Products &amp; Solutions</h4>
            <ul>
              <li><Link to="/custom-software-development">Custom Software Development</Link></li>
              <li><Link to="/web-development">Website &amp; Web App Dev</Link></li>
              <li><Link to="/mobile-app-development">Android &amp; iOS Mobile Apps</Link></li>
              <li><Link to="/hospital-management-software">Hospital Software (Mediway)</Link></li>
              <li><Link to="/erp-software">Custom Manufacturing ERP</Link></li>
              <li><Link to="/crm-software">Sales &amp; WhatsApp CRM</Link></li>
              <li><Link to="/noida">Noida &amp; NCR IT Services</Link></li>
              <li><Link to="/ghaziabad">Ghaziabad &amp; NCR IT Services</Link></li>
            </ul>
          </nav>

          {/* Column 2 — Company */}
          <nav className="footer-column" aria-label="Company navigation">
            <h4>Company</h4>
            <ul>
              {/* <li><Link to="/about">About Us</Link></li> */}
              {/* <li><Link to="/about">Our Team</Link></li> */}
              <li><Link to="/case-studies">Case Studies</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><a href="https://wa.me/918287999236?text=Hi!%20I%20am%20interested%20in%20career%20opportunities%20at%20Wayug%20Infotech." target="_blank" rel="noopener noreferrer">Careers</a></li>
              <li><a href="https://wa.me/918287999236?text=Hi!%20I%20am%20interested%20in%20partnering%20with%20you." target="_blank" rel="noopener noreferrer">Partners</a></li>
            </ul>
          </nav>

          {/* Column 3 — Support */}
          <nav className="footer-column" aria-label="Support navigation">
            <h4>Support</h4>
            <ul>
              <li><a href="https://wa.me/918287999236?text=Hi!%20I%20need%20access%20to%20the%20Client%20Portal." target="_blank" rel="noopener noreferrer">Client Portal</a></li>
              <li><a href="https://wa.me/918287999236?text=Hi!%20I%20am%20looking%20for%20documentation." target="_blank" rel="noopener noreferrer">Documentation</a></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><a href="https://wa.me/918287999236?text=Hi!%20Are%20there%20any%20service%20outages?" target="_blank" rel="noopener noreferrer">Service Status</a></li>
              <li><a href="https://wa.me/918287999236?text=Hi!%20I%20have%20a%20question%20about%20the%20Privacy%20Policy." target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
              <li><a href="https://wa.me/918287999236?text=Hi!%20I%20have%20a%20question%20about%20the%20Terms%20of%20Service." target="_blank" rel="noopener noreferrer">Terms of Service</a></li>
            </ul>
          </nav>

        </div>
      </div>

      {/* ── Footer Bottom ── */}
      <div className="footer-bottom container">
        <p>© {new Date().getFullYear()} Wayug Infotech Solutions Pvt. Ltd. All rights reserved.</p>
        <div className="footer-badges" aria-label="Certifications and technologies">
          <span className="cert-badge" title="ISO 20000 Certified">ISO 20000</span>
          <span className="cert-badge" title="ISO 27001 Information Security Certified">ISO 27001</span>
          <span className="cert-badge" title="ISO 9001 Quality Management Certified">ISO 9001</span>
          <span className="cert-badge" title="Docker Certified">Docker</span>
          <span className="cert-badge" title="Certified Kubernetes Administrator">CKA</span>
        </div>
      </div>

    </footer>
  );
};

export default Footer;